// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2dLVa","legacyBtn":"MutateMid_legacyBtn__zaGBo"};